import React from 'react'

import useJurisdiction from '../../utils/Jurisdiction'

import '../form/RitForm.css'

export default function JurisdictionSelector() {
	const { inputForm, setInputForm } = useJurisdiction()

	function onChange(name, value) {
		setInputForm({ ...inputForm, [name]: value })
	}

	return (
		<div>
			<div className='form' style={{ marginTop: '50px' }}>
				<select
					name='jurisdiction'
					value={inputForm.initialJurisdiction}
					onChange={(e) => onChange('initialJurisdiction', e.target.value)}
					label=''
					className='jurisdiction-Input'
					required={true}
				>
					<option value=''></option>
					<option value='GASB'>GASB</option>
					<option value='US GAAP'>US GAAP</option>
					<option value='IFRS 16'>IFRS 16</option>
				</select>
				<label htmlFor='jurisdiction' className='no-border'>
					<span className='label-font'>
						Which jurisdiction does your lease fall under?
					</span>
				</label>
			</div>
			{inputForm.initialJurisdiction === 'GASB' ? (
				<div className='form' style={{ marginTop: '50px' }}>
					<select
						name='GASB'
						value={inputForm.gasbJurisdiction}
						onChange={(e) => onChange('gasbJurisdiction', e.target.value)}
						required={true}
						className='jurisdiction-subInput'
					>
						<option value=''></option>
						<option value='GASB 62'>GASB 62</option>
						<option value='GASB 87'>GASB 87</option>
					</select>
					<label htmlFor='jurisdiction' className='no-border'>
						<span className='label-font'>GASB 62 or GASB 87?</span>
					</label>
				</div>
			) : null}
			{inputForm.initialJurisdiction === 'US GAAP' ? (
				<div className='form' style={{ marginTop: '50px' }}>
					<select
						name='US GAAP'
						value={inputForm.gaapJurisdiction}
						onChange={(e) => onChange('gaapJurisdiction', e.target.value)}
						className='jurisdiction-subInput'
						required={true}
					>
						<option value=''></option>
						<option value='ASC 840'>ASC 840</option>
						<option value='ASC 842'>ASC 842</option>
					</select>
					<label htmlFor='jurisdiction' className='no-border'>
						<span className='label-font'>ASC 840 or ASC 842?</span>
					</label>
				</div>
			) : null}
		</div>
	)
}
